import { useAppContext } from "../../../../../../lib/appContext";
import { Destination } from "./types";
import { getHostname } from "../../../../../../core/helpers";

export const useLandingUrl = () => {
  const { countryCode, businessUnitSlug } = useAppContext();
  const domain = getHostname(countryCode);
  return (destination: Destination) => {
    const isContinent = !Boolean(destination.continent);
    const continentSlug = isContinent ? destination.slug : destination.continent!.slug;
    const countrySlug = isContinent ? "" : `/${destination.slug!}`;
    return `${domain}/${businessUnitSlug}/destino/${continentSlug}${countrySlug}`;
  };
};
